<template>
  <div class="offers">
    <a v-for="(image, index) in slicedImages" :key="index" :href="image.targetUrl">
      <img class="offers__picture" :src="image.imageUrl" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  computed: {
    slicedImages() {
      return this.images.slice(0, 5);
    }
  }
}
</script>

<style lang="scss" scoped>
  .offers {
    display: flex;
    gap: 20px;
    
    &__picture {
      width: 152px;
      height: 90px;
      border-radius: var(--border-radius-lg);
      box-shadow: var(--shadow);
      
      &:hover {
        box-shadow: var(--shadow-hover);
      }
    }
  }
</style>


